import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type RedirectTarget = '_self' | '_blank';

const useRedirectWithUTM = (): ((targetUrl: string, target?: RedirectTarget) => void) => {
  const location = useLocation();

  const redirectToWithUTM = useCallback(
    (targetUrl: string, target: RedirectTarget = '_self') => {
      const currentUrlParams = new URLSearchParams(location.search);
      const utmParams: string[] = [];

      currentUrlParams.forEach((value, key) => {
        if (key.startsWith('utm_')) {
          utmParams.push(`${key}=${value}`);
        }
      });

      let urlWithUtm = targetUrl;
      if (utmParams.length > 0) {
        urlWithUtm += (urlWithUtm.includes('?') ? '&' : '?') + utmParams.join('&');
      }

      if (target === '_blank') {
        window.open(urlWithUtm, '_blank', 'noopener,noreferrer');
        return;
      }

      window.location.href = urlWithUtm;
    },
    [location]
  );

  return redirectToWithUTM;
};

export default useRedirectWithUTM;
